var _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 73 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.724778,0,0,1,-3.29591e-13,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 52.273,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100,3.409C100,1.528 97.892,0 95.296,0L4.704,0C2.108,0 0,1.528 0,3.409C0,5.291 2.108,6.818 4.704,6.818L95.296,6.818C97.892,6.818 100,5.291 100,3.409Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,22.7273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,3.409C100,1.528 97.892,0 95.296,0L4.704,0C2.108,0 0,1.528 0,3.409C0,5.291 2.108,6.818 4.704,6.818L95.296,6.818C97.892,6.818 100,5.291 100,3.409Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,45.4545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,3.409C100,1.528 97.892,0 95.296,0L4.704,0C2.108,0 0,1.528 0,3.409C0,5.291 2.108,6.818 4.704,6.818L95.296,6.818C97.892,6.818 100,5.291 100,3.409Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.a2c34988e18b96c1658b6eee955504dc.svg";
export { ForwardRef as ReactComponent };